/**
 * Wrappers forms methods mixin
 */
export default {
  methods: {
    setErrorVisible (msg = '') {
      this.$refs[this.type].setErrorVisible(msg)
    },
    hideErrors () {
      this.$refs[this.type].hideErrors()
    }
  }
}
